<!-- State: Person Dropdown -->
<ng-container *ngIf="currentState === 'person-dropdown'">
  <div class="input-beneficiary-card__type-section">
    <p class="c11n-text-md-bold">{{ content.BENEFICIARY_INDIVIDUAL_BY_NAME }}</p>
    <a
      *ngIf="showChangeType"
      c11n-link
      href="javascript:void(0)"
      [variant]="'primary-reinforced'"
      [iconName]="'edit'"
      [iconPosition]="'leading'"
      (click)="changeType.emit()"
    >
      {{ content.BENEFICIARY_CHANGE }}
    </a>
  </div>

  <div class="input-beneficiary-card__content-section">
    <div class="input-beneficiary-card__person-dropdown">
      <c11n-dropdown
        [labelText]="content.BENEFICIARY_DROPDOWN_LABEL"
        [placeholderText]="content.BENEFICIARY_DROPDOWN_PLACEHOLDER"
        [menuData]="personDropdownData"
        (stateChange)="handlePersonDropdownChange($event)"
      ></c11n-dropdown>
      <c11n-hint-error
        *ngIf="showSelectError"
        [hasError]="true"
        [size]="'medium'"
        [errorText]="content.BENEFICIARY_SELECT_ERROR"
        hintErrorId="bene-select-error"
      ></c11n-hint-error>
    </div>
  </div>

  <div *ngIf="mode === 'edit'" class="input-beneficiary-card__cancel-section">
    <button
      c11n-link
      [variant]="'secondary-reinforced'"
      class="input-beneficiary-card__cancel-link"
      (click)="cancel.emit()"
    >
      {{ content.BENEFICIARY_CANCEL }}
    </button>
  </div>
</ng-container>

<!-- State: Inline Form (Add new person / Edit existing person) -->
<ng-container *ngIf="currentState === 'inline-form'">
  <div class="input-beneficiary-card__type-section">
    <p class="c11n-text-md-bold">{{ content.BENEFICIARY_INDIVIDUAL_BY_NAME }}</p>
    <a
      *ngIf="showChangeType"
      c11n-link
      href="javascript:void(0)"
      [variant]="'primary-reinforced'"
      [iconName]="'edit'"
      [iconPosition]="'leading'"
      (click)="changeType.emit()"
    >
      {{ content.BENEFICIARY_CHANGE }}
    </a>
  </div>

  <div class="input-beneficiary-card__content-section">
    <!-- Person dropdown showing "Add new person" selected (only in add mode) -->
    <div *ngIf="mode === 'add'" class="input-beneficiary-card__person-dropdown">
      <c11n-dropdown
        [labelText]="content.BENEFICIARY_DROPDOWN_LABEL"
        [placeholderText]="content.BENEFICIARY_DROPDOWN_PLACEHOLDER"
        [menuData]="personDropdownData"
        [activeItems]="'add-new-person'"
        (stateChange)="handleInlineFormPersonChange($event)"
      ></c11n-dropdown>
    </div>

    <p class="c11n-text-md">{{ content.BENEFICIARY_ALL_FIELDS_REQUIRED }}</p>

    <!-- First name / Last name row -->
    <div class="input-beneficiary-card__form-row">
      <div class="input-beneficiary-card__form-field">
        <label c11n-label for="bene-first-name" [size]="'medium'">{{
          content.BENEFICIARY_FIRST_NAME_LABEL
        }}</label>
        <c11n-input [size]="'medium'">
          <input
            c11nInput
            [(ngModel)]="firstName"
            id="bene-first-name"
            type="text"
            [placeholder]="content.BENEFICIARY_FIRST_NAME_LABEL"
            (ngModelChange)="validateFirstName()"
            (blur)="validateFirstName()"
          />
        </c11n-input>
        <c11n-hint-error
          [hasError]="!validFirstName"
          [size]="'medium'"
          [errorText]="content.BENEFICIARY_FIELD_REQUIRED_ERROR"
          hintErrorId="bene-firstname-error"
        ></c11n-hint-error>
      </div>

      <div class="input-beneficiary-card__form-field">
        <label c11n-label for="bene-last-name" [size]="'medium'">{{
          content.BENEFICIARY_LAST_NAME_LABEL
        }}</label>
        <c11n-input [size]="'medium'">
          <input
            c11nInput
            [(ngModel)]="lastName"
            id="bene-last-name"
            type="text"
            [placeholder]="content.BENEFICIARY_LAST_NAME_LABEL"
            (ngModelChange)="validateLastName()"
            (blur)="validateLastName()"
          />
        </c11n-input>
        <c11n-hint-error
          [hasError]="!validLastName"
          [size]="'medium'"
          [errorText]="content.BENEFICIARY_FIELD_REQUIRED_ERROR"
          hintErrorId="bene-lastname-error"
        ></c11n-hint-error>
      </div>
    </div>

    <!-- Date of birth / State of residence row -->
    <div class="input-beneficiary-card__form-row">
      <div class="input-beneficiary-card__form-field">
        <c11n-date-picker
          [labelText]="content.BENEFICIARY_DOB_LABEL"
          [size]="'medium'"
          [hasError]="!validDateOfBirth"
          [hasCustomHintError]="true"
          (change)="handleDateChange($event)"
        >
          <input
            c11nDatePickerInput
            type="date"
            [(ngModel)]="dateOfBirth"
            id="bene-dob"
            name="bene-dob"
            [min]="minDate"
            [max]="todayDate"
            (blur)="validateDateOfBirth()"
          />
        </c11n-date-picker>
        <c11n-hint-error
          [hasError]="!validDateOfBirth"
          [size]="'medium'"
          [errorText]="dateOfBirthErrorText"
          hintErrorId="bene-dob-error"
        ></c11n-hint-error>
      </div>

      <div class="input-beneficiary-card__form-field input-beneficiary-card__state-field">
        <c11n-dropdown
          [labelText]="content.BENEFICIARY_STATE_LABEL"
          [placeholderText]="'Select one'"
          [menuData]="stateOptions"
          [activeItems]="stateOfResidence ? [stateOfResidence] : []"
          (stateChange)="handleStateDropdownChange($event)"
          (focusout)="validateStateOfResidenceOnBlur()"
        ></c11n-dropdown>
        <c11n-tooltip
          class="input-beneficiary-card__state-tooltip"
          [labelText]="''"
          [direction]="'above'"
        >
          <span c11nTooltipContent class="c11n-text-md--crop">{{
            content.BENEFICIARY_STATE_TOOLTIP
          }}</span>
        </c11n-tooltip>
        <c11n-hint-error
          [hasError]="!validStateOfResidence"
          [size]="'medium'"
          [errorText]="content.BENEFICIARY_FIELD_REQUIRED_ERROR"
          hintErrorId="bene-state-error"
        ></c11n-hint-error>
      </div>
    </div>

    <!-- Save / Cancel actions -->
    <div class="input-beneficiary-card__save-section">
      <c11n-button
        *ngIf="!isSaving"
        [variant]="'secondary'"
        [size]="'medium'"
        [labelText]="content.BENEFICIARY_SAVE_BUTTON"
        (clickEvent)="handleSave()"
      >
      </c11n-button>
      <c11n-button
        *ngIf="isSaving"
        [variant]="'secondary'"
        [size]="'medium'"
        [labelText]="'Saving...'"
      >
      </c11n-button>
      <button
        c11n-link
        [variant]="'secondary-reinforced'"
        class="input-beneficiary-card__cancel-link"
        (click)="cancel.emit()"
      >
        {{ content.BENEFICIARY_CANCEL }}
      </button>
    </div>
  </div>
</ng-container>
